// components/FAQAccordion.js
"use client";
import { useState } from "react";
import Link from "next/link";
import Script from 'next/script';

import AccordionItem from "./AccordionItem";

const FAQAccordion = ({ isHomePage = false, faqItems }) => {
  const [openIndex, setOpenIndex] = useState(1);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

    // Add structured data
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <>
     <Script id="faq-schema" type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </Script>
    <section
      className={`relative ${
        isHomePage ? "pt-40 md:pt-38 sm:pt-40" : "pt-40 md:pt-60 sm:pt-40"
      } pb-20 sm:py-40 min-h-screen flex items-center justify-center bg-dark-background`}
    >
      <div className="absolute inset-0 bg-[radial-gradient(#334155_1px,transparent_1px)] [background-size:16px_16px]"></div>

      <div className="relative z-5 w-full max-w-3xl px-3 sm:px-4 mx-auto">
        <div className="text-center mb-6 sm:mb-12">
          <span className="inline-block px-2 py-1 text-base font-medium text-primary-500 bg-primary-transparent rounded-full mb-2 sm:mb-4">
            Common Questions
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-dark-text-primary mb-2 sm:mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-base sm:text-lg text-dark-text-secondary max-w-2xl mx-auto">
            Find answers to our most common inquiries below.
          </p>
        </div>

        <div className="space-y-2 sm:space-y-3">
          {faqItems.map((item) => (
            <AccordionItem
              key={item.id}
              item={item}
              isOpen={openIndex === item.id}
              onClick={() => toggleAccordion(item.id)}
            />
          ))}
        </div>

        <div className="mt-6 sm:mt-12 text-center">
          <p className="text-base sm:text-lg text-dark-text-secondary mb-2 sm:mb-4">
            Didn't find what you're looking for?
          </p>
          <Link href="/contact">
            <button className="px-4 py-2 bg-primary-500 text-white text-base sm:text-lg font-medium rounded-md hover:bg-primary-600 transition-colors shadow-primary-sm hover:shadow-primary-md">
              Contact Our Support Team
            </button>
          </Link>
        </div>
      </div>
    </section>
     </>
  );
};

export default FAQAccordion;